import { createHighlighter, type BundledLanguage, type BundledTheme, type HighlighterGeneric } from 'shiki';

let highlighter: HighlighterGeneric<BundledLanguage, BundledTheme> = null;

export async function getHighlighter()
{
    if (!highlighter)
    {
        highlighter = await createHighlighter({
            themes: [
                'github-dark',
                'github-light'],
            langs: [
                'html',
                'javascript',
                'typescript',
                'csharp',
                'sql',
                'vue'
            ]
        });
    }

    return highlighter;
}
